const locale ={
    HELP :"Ayuda",
    PRIVACY:"Privacidad",
    TERMS:"Términos",
}

export default locale